var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticClass:"scrollable pa-2",attrs:{"elevation":"1","rounded":"","outlined":_vm.outlined,"id":"scroller"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }